import { Component, Input } from '@angular/core';
import {
	DropdownControlComponent,
	DropdownOption,
} from '../../../controls/standard/dropdown-control/dropdown-control.component';
import { BaseFieldComponent } from '../base-field/base-field.component';
import { AppModule } from '../../../../modules/app.module';
import { ZorroModule } from '../../../../modules/zorro.module';
import { ThirdPartyModule } from '../../../../modules/third-party.module';
import { AngularModule } from '../../../../modules/angular.module';
import { ClientAccountType } from '@mira-avant/mtlibs';

@Component({
	selector: 'app-account-type-field',
	standalone: true,
	imports: [AppModule, ZorroModule, ThirdPartyModule, AngularModule, DropdownControlComponent],
	templateUrl: './account-type-field.component.html',
	styleUrl: './account-type-field.component.scss',
})
export class AccountTypeFieldComponent extends BaseFieldComponent {
	//convert the value of the ClientAccountType enum to DropdownOption
	public options: DropdownOption[] = Object.keys(ClientAccountType).map(key => {
		return { value: key, label: key };
	});
}
